import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d39939e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-detail padding" }
const _hoisted_2 = { class: "bread" }
const _hoisted_3 = { class: "bd" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新闻详情", -1))
const _hoisted_6 = { class: "bg" }
const _hoisted_7 = { class: "head" }
const _hoisted_8 = { class: "b" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "p-n" }
const _hoisted_11 = {
  key: 1,
  class: "link gd"
}
const _hoisted_12 = {
  key: 3,
  class: "link gd"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回列表", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: { path: '/news', query: { id: _ctx.channel.id } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.channel.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.content.title), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, "发布时间：" + _toDisplayString(_ctx.common.formatTime(_ctx.content.publishtime + '000')), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: "desc",
          innerHTML: _ctx.content.content2
        }, null, 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.prev)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { path: '/news-detail/' + _ctx.prev.id },
                class: "link gd"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("上一篇：" + _toDisplayString(_ctx.prev.title), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, "上一篇：无")),
          (_ctx.next)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: { path: '/news-detail/' + _ctx.next.id },
                class: "link gd"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下一篇：" + _toDisplayString(_ctx.next.title), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, "下一篇：无"))
        ])
      ]),
      _createVNode(_component_router_link, {
        to: { path: '/case', query: { id: _ctx.channel.id } },
        class: "more border gd"
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _hoisted_14
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}